import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Crop, CropRotate, DeleteOutlined } from '@mui/icons-material';
import { Edit } from '../../constructor/work/Edit';
import { useHandlerNotificationApp } from '../../hooks/useHandlerNotificationApp';

export const ButtonAddPruning = () => {
  const { addNotification } = useHandlerNotificationApp();
  const [isAddPruning, setIsAddPruning] = useState(() => !!Edit.drawingSubstrate?.pruningObject);
  const handleCrop = () => {
    if (Edit.drawingSubstrate) {
      if (!isAddPruning) {
        Edit.drawingSubstrate.createPruningObject();
      } else {
        Edit.drawingSubstrate.runCropAction();
      }
      setIsAddPruning(!isAddPruning);
    } else {
      addNotification({
        messageError: 'Для обрезки необходимо добавить чертеж-подложку',
        typeMessage: 'warning',
      });
    }
  };
  const handleRemoveCrop = () => {
    if (Edit.drawingSubstrate) {
      Edit.drawingSubstrate.removePruningObj();
      setIsAddPruning(false);
    }
  };

  return (
    <>
      <Box width="100%" mb="20px">
        <Button
          fullWidth
          variant="outlined"
          onClick={handleCrop}
          sx={{
            '&': {
              border: '1px solid #97A408',
              borderRadius: '10px',
              height: '50px',
              color: '#fff',
            },
          }}
          startIcon={isAddPruning ? <Crop /> : <CropRotate />}
        >
          <Typography color="#e5e5e5" fontSize="14px">
            {isAddPruning ? 'Обрезать' : 'Добавить обрезку'}
          </Typography>
        </Button>
      </Box>
      {isAddPruning && (
        <Box width="100%" mb="20px">
          <Button
            fullWidth
            variant="outlined"
            onClick={handleRemoveCrop}
            sx={{
              '&': {
                border: '1px solid #97A408',
                borderRadius: '10px',
                height: '50px',
                color: '#fff',
              },
            }}
            startIcon={<DeleteOutlined />}
          >
            <Typography color="#e5e5e5" fontSize="14px">
              Удалить обрезку
            </Typography>
          </Button>
        </Box>
      )}
    </>
  );
};
